import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/time_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-7063f346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-selector-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time-icon-div" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "time-icon",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "select-container" }
const _hoisted_4 = { class: "small-text inner-text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "select-container" }
const _hoisted_7 = { class: "small-text inner-text" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([
          'hour-selector-div',
          {
            'hour-selector-div-open': _ctx.hourClicked,
          },
        ]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHour && _ctx.openHour(...args)))
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.hour_selected) + " h", 1)
      ], 2), [
        [_directive_click_away, _ctx.closeHourDropdown]
      ]),
      (_ctx.hourClicked)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
          'select-options-div',
          {
            'select-options-div-opened-hours': _ctx.hourClicked,
          },
        ])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hourOptions, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  class: "small-text",
                  onClick: ($event: any) => (_ctx.selectHour(item))
                }, _toDisplayString(item) + " " + _toDisplayString(_ctx.hour_symbol), 9, _hoisted_5))
              }), 128))
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([
          'minutes-selector-div',
          {
            'minutes-selector-div-open': _ctx.minutesClicked,
          },
        ]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openMinutes && _ctx.openMinutes(...args)))
      }, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.minutes_selected) + " " + _toDisplayString(_ctx.minute_symbol), 1)
      ], 2), [
        [_directive_click_away, _ctx.closeMinutesDropdown]
      ]),
      (_ctx.minutesClicked)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
          'select-options-div',
          {
            'select-options-div-opened-minutes': _ctx.minutesClicked,
          },
        ])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minutesOptions, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  class: "small-text",
                  onClick: ($event: any) => (_ctx.selectMinutes(item))
                }, _toDisplayString(item) + " " + _toDisplayString(_ctx.minute_symbol), 9, _hoisted_8))
              }), 128))
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}